import { Theme } from '@mui/material';

export const getNewsletterSectionStyles = (theme: Theme) => ({
	root: {
		display: 'flex',
		justifyContent: 'space-between',
		backgroundColor: '#0A0A0A',
		py: '56px',
		px: '160px',
		gap: '32px',

		'@media screen and (max-width: 1440px)': {
			py: '48px',
			px: '16px',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
		}
	},
	title: {
		fontFamily: 'Integral CF',
		fontSize: '32px',
		fontWeight: 400,
		lineHeight: '42px',
		color: '#FFFFFF',

		'@media screen and (max-width: 1440px)': {
			textAlign: 'center',
		}
	},
	subtitle: {
		fontFamily: 'Integral CF',
		fontStyle: 'italic',
		fontWeight: 400,
		fontSize: '14px',
		lineHeight: '21px',
		color: '#FFFFFF',

		'@media screen and (max-width: 1440px)': {
			textAlign: 'center',
		}
	},
	inputs: {
		width: { xs: '100%', sm: 'auto' },
		display: { xs: 'flex' },
		flexDirection: { xs: 'column', sm: 'unset' },
		alignItems: { xs: 'center', sm: 'unset' },
		gap: { xs: '10px', sm: '15px', md: '20px', lg: '25px', xl: '30px' },
	},
	textField: {
		width: { xs: '100%', sm: '380px' },
		maxWidth: '380px',

		'& .MuiInputBase-root': {
			borderBottom: '1px solid #FFFFFF',

			'& .MuiInput-input': {
				fontFamily: 'Montserrat',
				fontWeight: '600',
				fontSize: '14px',
				color: '#FFFFFF',
				lineHeight: '21px',
				py: '16px',

				"&::placeholder": {
					opacity: 1,
					fontFamily: 'Integral CF',
					fontWeight: '400',
					fontSize: '14px',
					lineHeight: '21px',
					color: '#FFFFFF',
				},
			},
		}
	},
	subscribeButton: {
		width: 'auto',
		minWidth: '150px',
		height: '52px',
		backgroundColor: 'white',
		fontFamily: 'Integral CF',
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '17px',

		'&:hover': {
			color: '#FFFFFF',
			backgroundColor: '#000000',
		},
	},
});
